import { gql } from '@apollo/client'

const GET_NONPROFIT_ORG_DONATIONS_DETAILS_QUERY = gql`
  query nonprofitOrgDonationsDetails($nonprofitOrgId: Int) {
    nonprofitOrgDonationsDetails(nonprofitOrgId: $nonprofitOrgId) {
      state
      onboardingUrl
      errors {
        code
      }
    }
  }
`

export default GET_NONPROFIT_ORG_DONATIONS_DETAILS_QUERY
